module.exports = __webpack_public_path__ + "img/tpay-landing-page-ar.5812cf1c.png";